/**
 * Modulo Status
 * @module abstracts/status
 * @namespace Abstracts/Status
 */
import Backbone from 'backbone'
import Entity from './entity'

/**
 * Classe responsável por armazenar todos os status da aplicação
 * @classdesc Funciona como um model em duas camadas
 * Cada entidade é um atributo do Model Status e seu valor é um model SingleStatus
 *
 * @name Status
 * @typedef {Object} Status
 * @memberof abstracts/status
 * @extends Backbone.Model
 * @see {@link https://backbonejs.org/#Model}
 */
class Status extends Backbone.Model {
    /**
     * Construtor da classe Status
     *
     * @return {void}
     */
    initialize () {
        // super.set("core", new Entity({ status: "unstarted" }));
        this.on('update', (model) => {
            // console.log("Status Update" , model);
        })
    }

    /**
     * Atualiza um estado de uma entidade
     *
     * @param {string} entity - Nome da Entidade
     * @param {string} status - Nome do Estado (Ex.: status, logged, active)
     * @param {string} value - Valor do Estado (Ex.: started, true, false)
     *
     * @return {void}
     */
    update (entity, status, value) {
        const e = this._getEntity(entity)

        if (e) {
            e.set(status, value)
        }

        if (status === 'status') {
            this.trigger('update', this)
        }
    }

    /**
     * Retorna o último valor de um estado de uma entidade
     *
     * @param {string} entity - Nome da Entidade
     * @param {string} status - Nome do Estado (Ex.: status, logged, active)
     *
     * @return {string} status - Último valor do estado
     */
    get (entity, status) {
        const e = super.get(entity)

        // Se para aquela entidade não houve nenhum status registrado
        // retorna falso
        if (!e) {
            return false
        }

        // Retorna o status salvo daquela entidade
        return e.get(status)
    }

    /**
     * Retorna o histórico de um estado de uma entidade
     *
     * @param {string} entity - Nome da Entidade
     * @param {string} status - Nome do Estado (Ex.: status, logged, active)
     *
     * @return {array} status - Histórico de estados
     */
    getHistory (entity, status) {
        const e = super.get(entity)

        if (!e) {
            return false
        }

        // Retorna o historico de status
        return e.getAll(status)
    }

    /**
     * Sobrescreve o metodo pai da collection toJSON
     * Para integrar um toJSON a classe single-status
     *
     *
     * @return {object} Status - Estados da aplicação
     */
    toJSON () {
        const json = super.toJSON()
        for (const key of Object.keys(json)) {
            json[key] = json[key].toJSON()
        }
        return json
    }

    /**
     * Verifica se aquela entidade já está salva
     * Senão a salva e define listerners para ela
     *
     * @param {entidade} - Entidade para ser salva
     * @return {Entity} - Retorna a Entidade
     */
    _getEntity (entity) {
        if (!entity) {
            return false
        }

        // Se não há nada salvo para aquela entidade a cria vazia
        if (!super.get(entity)) {
            const e = new Entity({
                status: 'unstarted'
            })

            super.set(entity, e)
        }

        return super.get(entity)
    }
}

window.GPAbstractModules = window.GPAbstractModules || {}
window.GPAbstractModules.Status = Status
